import { api } from '../../DefaultService';
import {
  IGeneralRecognitionCreateProps,
  IGeneralRecognitionProps,
  IGeneralRecognitionUpdateParams,
} from './types';

const ENDPOINT = 'v1/recognitions/general';

export const createGeneralRecognitionAsync = async (
  data: IGeneralRecognitionCreateProps,
): Promise<IGeneralRecognitionProps> => {
  return await api
    .post(`${ENDPOINT}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const updateGeneralRecognitionAsync = async ({
  id,
  data,
}: IGeneralRecognitionUpdateParams): Promise<IGeneralRecognitionProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};

export const getGeneralRecognitionByIdAsync = async (
  id: number,
): Promise<IGeneralRecognitionProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.userMessage || 'Erro interno do servidor!',
      );
    });
};
